/**
 * VERSIONE LIBRERIA 3.0
 */
var RenderEvent = Class.extend({
    eventName : null,
    type :null,
    pk : null,
    params : null,
    key : null,
    init : function (eventName,type,pk,key,params) {
        this.eventName = eventName;
        this.type = type;
        this.pk = pk;
        this.params = params;
        this.key = key;
    }
});